const settings = window.settings;
//settings.baseApiUrl = 'https://' + window.settings;

export default settings;
